import { Body2 } from 'ui/theme';
import {
  StyledErrorBanner,
  StyledWarningBanner,
  ChangelogContainer,
  RetryLink,
  StyledSpinnerContainer,
  StyledSpinner,
  NoResults,
} from './PublishJourneyModal.styles';
import { Changelog } from '../../Changelog';
import { parseChangelogData } from '../../../utils';

export const WORKFLOW_CHANGE_LOG_COLUMN_ACTION = 'workflow-change-log-column-action';
export const WORKFLOW_CHANGE_LOG_COLUMN_NODETYPE = 'workflow-change-log-column-nodetype';
export const WORKFLOW_CHANGE_LOG_NO_RESULTS = 'workflow-change-log-no-results';
export const WORKFLOW_CHANGE_LOG_SPINNER = 'workflow-change-log-spinner';
export const WORKFLOW_CHANGE_LOG_RESULTS = 'workflow-change-logresults';
export const WORKFLOW_CHANGE_LOG_RESULTS_ROW = 'workflow-change-log-results-row';
export const WORKFLOW_CHANGE_LOG_ERROR = 'workflow-change-log-error';

type ChangeLogResultsTableProps = {
  data: any;
  isLoading: boolean;
  hasError: boolean;
  retryDiffQuery: () => void;
};

export const ChangeLogResultsTable = ({
  data,
  isLoading,
  hasError,
  retryDiffQuery,
}: ChangeLogResultsTableProps) => {
  if (isLoading) {
    return (
      <StyledSpinnerContainer>
        <StyledSpinner data-test={WORKFLOW_CHANGE_LOG_SPINNER} size={36} />
        <span>Comparing differences....</span>
      </StyledSpinnerContainer>
    );
  }
  if (hasError) {
    return (
      <StyledErrorBanner data-test={WORKFLOW_CHANGE_LOG_ERROR}>
        There was an issue with trying to display the changes you’ve made.
        <RetryLink onClick={retryDiffQuery} tabIndex={0}>
          Please try again.
        </RetryLink>
      </StyledErrorBanner>
    );
  }
  const parsedData = parseChangelogData(data);
  return (
    <>
      <Body2>This will overwrite the running journey with the following changes:</Body2>
      <ChangelogContainer>
        {!parsedData.length ? (
          <NoResults data-test={WORKFLOW_CHANGE_LOG_NO_RESULTS}>
            No differences were found between the draft and published journey.
          </NoResults>
        ) : (
          <Changelog
            parsedData={parsedData}
            changelogRowTest={WORKFLOW_CHANGE_LOG_RESULTS_ROW}
            changelogTableTest={WORKFLOW_CHANGE_LOG_RESULTS}
          />
        )}
      </ChangelogContainer>
      <StyledWarningBanner Icon={null}>
        Users currently in this journey will continue on in the new version of the journey when they
        exit the tile they&apos;re on. Users in deleted tiles will exit the journey.
      </StyledWarningBanner>
    </>
  );
};
